import { render, staticRenderFns } from "./DashboardTemplateDrawer.vue?vue&type=template&id=38a548ed&scoped=true"
import script from "./DashboardTemplateDrawer.vue?vue&type=script&setup=true&lang=ts"
export * from "./DashboardTemplateDrawer.vue?vue&type=script&setup=true&lang=ts"
import style0 from "./DashboardTemplateDrawer.vue?vue&type=style&index=0&id=38a548ed&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38a548ed",
  null
  
)

export default component.exports